import {
  searchAndFiltersFilterClickParams,
  searchAndFiltersFinishedParams,
  searchAndFiltersShowAllClickParams,
  searchAndFiltersStartedParams,
} from '@wix/bi-logger-media-manager-g6/v2/types';
import { useCallback, useMemo } from 'react';
import { bi } from '../../../../services/loggers/bi';
import { now } from '../../../env/performance';
import { RouteMatcher } from '../../../RouteHelpers';
import { ClickOriginsSearchAndFiltersClear, ErrorTypes } from './useTrackSearchAndFiltersAnalytics.types';
import {
  searchAndFiltersFilterClick,
  searchAndFiltersFinished,
  searchAndFiltersNoResultsTryToClick,
  searchAndFiltersShowAllClick,
  searchAndFiltersStarted,
} from '@wix/bi-logger-media-manager-g6/v2';
import { useSearchResultsBI } from '../../../../containers/FilesManager/SearchResults/useSearchResultsBI';
import { BIPageName } from '../../../../constants/Bi';

let currentRequest: searchAndFiltersStartedParams = null;
let requestStartTime: number = null;

export const useTrackSearchAndFiltersAnalytics = () => {
  const trackSearchAndFiltersFinished = useCallback((params: searchAndFiltersFinishedParams = {}) => {
    if (!currentRequest) {
      return;
    }

    const { errorType = null } = params;

    bi.logger().report(
      searchAndFiltersFinished({
        ...currentRequest,
        ...params,
        ...(errorType && errorType === ErrorTypes.CanceledByUser
          ? {} // do not add `loadingTime` param if request was cancelled
          : { loadingTime: Math.round(now() - requestStartTime) }),
      }),
    );
    currentRequest = null;
    requestStartTime = null;
  }, []);

  const { setNewSearchId } = useSearchResultsBI();

  return useMemo(
    () => ({
      trackSearchAndFiltersClear: (clickOrigin: ClickOriginsSearchAndFiltersClear) =>
        bi.logger().report(searchAndFiltersNoResultsTryToClick({ clickOrigin })),
      trackSearchAndFiltersStarted: (params: searchAndFiltersStartedParams = {}) => {
        if (currentRequest) {
          trackSearchAndFiltersFinished({
            ...currentRequest,
            ...{ success: false, errorType: ErrorTypes.CanceledByUser },
          });
        }
        currentRequest = { ...params, search_id: setNewSearchId(), pageName: BIPageName.MediaManager };
        requestStartTime = now();
        bi.logger().report(searchAndFiltersStarted(currentRequest));
      },
      trackSearchAndFiltersShowAllClick: (params: searchAndFiltersShowAllClickParams = {}) =>
        bi.logger().report(searchAndFiltersShowAllClick(params)),
      trackSearchAndFiltersFilterClick: (params: searchAndFiltersFilterClickParams) =>
        bi.logger().report(searchAndFiltersFilterClick(params)),
      trackSearchAndFiltersFinished,
      trackSearchAndFiltersSubscribeToLoadFinish: (itemsLoadPromise, pathname: string) => {
        itemsLoadPromise
          .then((items) => {
            if (!RouteMatcher.isSearch(pathname)) {
              trackSearchAndFiltersFinished(
                items.length
                  ? { success: true }
                  : {
                      success: false,
                      numOfResults: 0,
                      errorType: ErrorTypes.NoResults,
                    },
              );
            }
          })
          .catch(() => {
            trackSearchAndFiltersFinished({
              success: false,
              errorType: ErrorTypes.Technical,
            });
          });
      },
    }),
    [trackSearchAndFiltersFinished, setNewSearchId],
  );
};
